import { Observable, combineLatest } from 'rxjs';
import { IInvestorUpdateStatus } from 'src/app/store/state/investor.state';
import * as UserActions from './../../../../store/user/actions/user.actions';
import { IAppState } from 'src/app/store/state/app.state';
import { Store } from '@ngrx/store';
import { ITaxDetails } from 'src/app/models/registration/taxDetails';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { InvestorFacade } from 'src/app/store/investor/facade/investor.facade';
import { Router } from '@angular/router';
import { NgForm, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { UtilitiesFacades } from 'src/app/store/utilities/facades/utilities.facades';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Country } from 'src/app/models/country';
import { AppConfig } from 'src/app/app.config';

@UntilDestroy()
@Component({
  selector: 'app-tax-details',
  templateUrl: './tax-details.component.html',
  styleUrls: ['./tax-details.component.scss']
})
export class TaxDetailsComponent implements OnInit {

  @ViewChild('f') form: NgForm;
  public taxDetailsForm: UntypedFormGroup;
  public RWTTaxRates$ = this.investorFacade.RWTTaxRateSchedule$;
  public isLoading = false;
  public updateFail = false;
  public updateSuccess = false;
  private investorUpdateStatus$ = this.investorFacade.investorUpdateStatus$;
  private countryList: Array<Country>;
  private preDefinedTaxRate = 0;
  private pir = '';
  private taxResidency = '';
  public taxDetailsUpdateMessage = '';
  public isInvestorProvidedTaxRateValid = true;

  private preDefinedInvestorTaxRate$: Observable<[number, boolean]> = this.investorFacade.preSelectedInvestorRWTTaxRate$;

  private investorTaxDetails$: Observable<ITaxDetails> = this.investorFacade.investorTaxDetails$;
  private canUserSelectTaxRate$: Observable<{ canUserSelectTaxRate: boolean, userCannotSelectTaxrateDescriptionText: string }> = this.investorFacade.canUserSelectTaxRate$;
  public canUserSelectTaxRate = true;
  public userCannotSelectTaxrateDescriptionText = '';


  constructor(
    private investorFacade: InvestorFacade, 
    private utilitiesFacades: UtilitiesFacades,
    private router: Router,
    private store: Store<IAppState>,
    private appConfig: AppConfig) { }

  ngOnInit(): void {
    this.initializeForm();
    this.setupDataSubscription();
  }

  private initializeForm() {
    this.taxDetailsUpdateMessage = this.appConfig.getTaxDetailsUpdateMessage();
    this.investorFacade.resetInvestorDetailsForm();
    this.taxDetailsForm = new UntypedFormGroup(
      {
        'marginalTaxRate': new UntypedFormControl('', Validators.required),
        'pir': new UntypedFormControl({ value: '', disabled: true }),
        'taxResidency': new UntypedFormControl({ value: '', disabled: true })
      }
    );
  }

  private setupDataSubscription() {

     this.getPIRAndTaxResidency();

    this.investorUpdateStatus$.pipe(untilDestroyed(this)).subscribe((investorUpdateStatus: IInvestorUpdateStatus) => {
      this.isLoading = investorUpdateStatus.isLoading;
      this.updateFail = investorUpdateStatus.updateFail;
      this.updateSuccess = investorUpdateStatus.updateSuccess;
    });

    this.preDefinedInvestorTaxRate$.pipe(untilDestroyed(this)).subscribe((t: [number, boolean]) => {
      this.preDefinedTaxRate = t[0];
      this.isInvestorProvidedTaxRateValid = t[1];
      this.patchFormValues();
    });

    

    this.canUserSelectTaxRate$.pipe(untilDestroyed(this)).subscribe((c: { canUserSelectTaxRate: boolean, userCannotSelectTaxrateDescriptionText: string }) => {
      this.canUserSelectTaxRate = c.canUserSelectTaxRate;
      this.enableDisableTaxRateSelector();
      this.userCannotSelectTaxrateDescriptionText = c.userCannotSelectTaxrateDescriptionText;
    });
  }

  private getPIRAndTaxResidency() {
    this.utilitiesFacades.getCountryList().subscribe((countryList: Country[]) => {
      this.countryList = countryList;
      if (this.countryList && this.countryList.length > 0) {
        this.investorTaxDetails$.pipe(untilDestroyed(this)).subscribe((t: ITaxDetails) => {
          this.pir = t.taxRate;
          if (t.countryTaxResidency && Number.isInteger(t.countryTaxResidency)) {
            this.taxResidency = this.countryList.filter(c => c.numericCountryCode == t.countryTaxResidency)[0].name;
          }
          else {
            this.taxResidency = t.countryTaxResidency.toString();
          }
          this.patchFormValues();
        });
      }
    });
  }

  private enableDisableTaxRateSelector() {
    if (this.canUserSelectTaxRate) {
      this.taxDetailsForm.controls['marginalTaxRate'].enable();
    } else {
      this.taxDetailsForm.controls['marginalTaxRate'].disable();
    }
  }

  private patchFormValues() {
    this.taxDetailsForm.patchValue({
      marginalTaxRate: this.preDefinedTaxRate,
      pir: (parseFloat(this.pir) * 100).toFixed(2) + ' %',
      taxResidency: this.taxResidency
    });

  }

  public onSubmit(form: NgForm) {
    const model = {
      marginalTaxRate: form.value.marginalTaxRate
    };

    this.investorFacade.saveInvestorDetails(model);
  }


  public onResetAndClose() {
    this.patchFormValues();
    // if (!this.showSpinner) {
    setTimeout(() => {
      this.router.navigate([{ outlets: { 'sidebar': null } }]);
    }, 300);
    this.store.dispatch(new UserActions.UserProfileEditClose());
    // }
  }

}
